import { render, staticRenderFns } from "./cModalAsignComment.vue?vue&type=template&id=2dbf8c70"
import script from "./cModalAsignComment.vue?vue&type=script&lang=js"
export * from "./cModalAsignComment.vue?vue&type=script&lang=js"
import style0 from "./cModalAsignComment.vue?vue&type=style&index=0&id=2dbf8c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports